<template>
  <v-menu v-model="menu" open-on-hover open-on-focus>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="materialCategoriesSelected"
        clearable
        chips
        multiple
        deletable-chips
        small-chips
        :items="materialCategoriesSelected"
        :loading="materialCategoriesLoading"
        :search-input.sync="materialCategoriesSearch"
        item-text="name"
        item-value="id"
        :label="noLabel ? '' : $t('MaterialCategory.title')"
        return-object
        v-bind="attrs"
        v-on="on"
        @focus="materialCategoriesSearch = ''"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="materialCategoriesSelected"
          :items="materialCategories"
          :search="materialCategoriesSearch"
          :filter="categoriesFilter"
          selection-type="independent"
          item-key="material_category_id"
          item-text="name"
          item-children="categories"
          selectable
          selected-color="primary"
          hoverable
          return-object
          :open.sync="categoriesOpen"
          @input="selectedMethod()"
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
// import MaterialCategories from "@/api/material_categories";
import Shops from "@/api/shops";

export default {
  name: "SearcherMaterialCategoriesWithDescendants",

  props: {
    value: Array,
    shopId: Number,
    noLabel: Boolean,
  },

  computed: {
    categoriesFilter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    if (this.shopId) {
      this.getMaterialCategoriesFromAPI();
    }
  },

  data: () => ({
    menu: false,
    materialCategories: [],
    materialCategoriesLoading: false,
    materialCategoriesSearch: "",
    materialCategoriesSelected: [],
    materialCategoriesSelectedItems: [],
    categoriesOpen: [],
  }),

  methods: {
    openTree(openArr) {
      this.categoriesOpen.slice(0);// 清除之前的打开状态
      for (var i = 0; i < openArr.length; i++) {
        this.categoriesOpen.push(openArr[i]);
        if (openArr[i].categories.length > 0) {
          this.openTree(openArr[i].categories);
        }
      }
    },

    getMaterialCategoriesFromAPI() {
      this.materialCategoriesLoading = true;
      Shops.shopPsiMaterialCategoyies({ shop_id: this.shopId })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materialCategories = response.data.shop_material_categories;
              this.openTree(this.materialCategories);
            }
            this.materialCategoriesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialCategoriesLoading = false;
          }.bind(this)
        );
    },
    selectedMethod() {
      if (this.materialCategoriesSelectedItems.length == 0) {
        this.materialCategoriesSelected.forEach((detail) => {
          this.addChildren(detail);
        });
      } else {
        this.materialCategoriesSelected.forEach((detail) => {
          if (
            this.materialCategoriesSelectedItems.findIndex(
              (item) => item.material_category_id == detail.material_category_id
            ) == -1
          ) {
            this.addChildren(detail);
          }
        });
      }
      this.materialCategoriesSelectedItems = this.materialCategoriesSelected;
    },

    addChildren(obj) {
      if (this.materialCategoriesSelected.findIndex((item) => item.material_category_id == obj.material_category_id) == -1) {
        this.materialCategoriesSelected.push(obj);
      }
      if (obj.categories && obj.categories.length) {
        obj.categories.forEach((item) => {
          this.addChildren(item);
        });
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialCategoriesSelectedItems = this.value ? this.value : [];
        this.materialCategoriesSelected = this.value ? this.value : [];
      },
    },
    materialCategoriesSelected: {
      handler() {
        this.$emit("input", this.materialCategoriesSelected);
      },
    },
    shopId: {
      handler() {
        if (this.shopId) {
          this.getMaterialCategoriesFromAPI();
        } else {
          this.materialCategories = [];
        }
      },
    },
  },
};
</script>
